/* ff-hero-cards: small behaviours for the home page hero.
   - the deck: Jan's featured portraits are dealt through the card fan as collector's cards, swipeable, the first
     card first
   - a Living Motion card plays only while it's the middle card on screen (and rests on its poster with reduced motion)
   - the cards lean toward a mouse or pen, and the middle card's foil follows it
   - proof numbers count up once, with their final width held so nothing shifts
   - the rating and review count refresh from the product's Loox reviews; the printed values stay if that fails */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  /* ---------------------------------------------------------------- the deck
     Jan, 2026-10-15: "instead of these 3 images, i want it to cycle smoothly and with no lag through all of
     jan's favorites from the hall ... interactive so the user can swipe through them ... make sure Ember is
     always featured in the center FIRST on load".

     The section prints three cards so the first frame needs nothing from the network: heroes 0 (the middle),
     -1 (left) and 1 (right). Jan's featured list (ffShowcase, the heroes ticked "Jan's featured" in the Hall)
     then fills the ring: the middle card, the right card, everyone else shuffled, the left card last.
     Nine slots stand at virtual positions cur-4 .. cur+4 and are recycled; only -2 .. 2 can ever be seen, so a
     slot always changes hero out of sight (even on a two-card flick), and the timer only deals the next hero
     once its picture has loaded and decoded. Each slot's place in the fan is one CSS number, --p (see
     ff-hero-cards.css).

     THE CARDS (Jan, 2026-10-23: "these cards on the home page should Jans Favorites as cards, and the cards should
     look like this instead of the hall ones ... make sure the home page cards have the custom look on them"). Each
     hero is the Hall's own collector's card, drawn by the binder (assets/ff-binder.js, FFBinder.mountCollector, which
     loads ff-collector.css itself) in the design saved for that hero (card_meta.look: its colours, a gold, silver or
     copper frame, a matte, foil or etched finish), with its collector number. Until the binder and the list are in,
     a card shows the same layout in a plain gold frame (the section prints three; cardHtml below draws the rest),
     and the binder's card fades in over it. Should the binder never come, those cards simply stay. */
  var RADIUS = 4, SHOWN = 3;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function sameHero(a, b) { return !!a && !!b && (a.key && b.key ? a.key === b.key || a.id === b.key || a.key === b.id : norm(a.name) === norm(b.name)); }

  /* The Hall's framing, so every portrait here sits exactly as Jan set it in the Hall (Jan, 2026-10-23: "if you are
     grabbing an image from the hall of heroes, it needs to inheret the resize i set up in the hall so it fits
     properly"): hoh-section-core.js hohImgStyle's order, this device's reframe first (the Hall keeps it in localStorage
     hoh-img-offsets-v1), then the hero's saved one, then the centre. X, Y and zoom resolve one by one. */
  var OFFS = null;
  function inR(v, a, b) { return typeof v === 'number' && v >= a && v <= b; }
  function framing(h) {
    if (!OFFS) { try { OFFS = JSON.parse(localStorage.getItem('hoh-img-offsets-v1') || '{}') || {}; } catch (e) { OFFS = {}; } }
    var k = String(h.id) + ':primary';
    return {
      x: inR(OFFS[k + ':x'], 0, 100) ? OFFS[k + ':x'] : inR(h.offsetX, 0, 100) ? h.offsetX : 50,
      y: inR(OFFS[k], 0, 100) ? OFFS[k] : inR(h.offsetY, 0, 100) ? h.offsetY : 50,
      z: inR(OFFS[k + ':zoom'], 100, 200) ? OFFS[k + ':zoom'] : inR(h.zoom, 100, 200) ? h.zoom : 100
    };
  }

  /* A hero from ffShowcase: the words the collector's card shows (ff-binder.js feHtml: the epithet, else the title,
     and the quote without its own quote marks) and the row the binder draws it from, framed as in the Hall. The cards
     show the Hall's stored 400 px thumbnail; the middle card gets a sharper one once it settles (sharpen). */
  function fromShowcase(h) {
    var m = h.card || {}, img = h.thumb || h.image || '', f = framing(h), at = f.x + '% ' + f.y + '%';
    return {
      id: h.id, key: norm(h.slug || h.id), url: h.url || '', name: h.name || 'Hero',
      type: [h.race, h.characterClass].filter(Boolean).join(' · '),
      epithet: m.epithet || m.title || '', quote: String(m.quote || '').replace(/^["“]+|["”]+$/g, ''),
      img: img, imgStyle: 'object-position:' + at + ';transform-origin:' + at + ';scale:' + f.z / 100 + ';',
      full: h.image || '', video: h.video || '',
      row: {
        id: h.id, slug: h.slug || '', name: h.name || '', race: h.race || '', character_class: h.characterClass || '',
        campaign: h.campaign || '', player_name: h.playerName || '', image_url: img, image_thumb_url: h.thumb || img,
        image_offset_x: f.x, image_offset_y: f.y, image_zoom: f.z, is_ff_portrait: h.isFF === true,
        card_meta: h.card || null, created_at: h.createdAt || ''
      }
    };
  }
  /* a printed card, as the deck knows it before the list arrives */
  function fromSlot(el) {
    var key = norm(el.getAttribute('data-ffhc-key'));
    var img = el.querySelector('.ffhc-cart img');
    var name = el.querySelector('.ffhc-cname');
    return {
      key: key, name: name ? name.textContent : '', url: key ? '/pages/hero?h=' + encodeURIComponent(key) : '',
      printed: el.firstElementChild ? el.firstElementChild.innerHTML : '', img: img ? img.getAttribute('src') : ''
    };
  }

  /* the same card the section prints */
  function cardHtml(h) {
    var art = h.video
      ? '<video src="' + esc(h.video) + '" poster="' + esc(h.img) + '" muted playsinline loop preload="none" data-ffhc-autoplay></video>'
      : '<img src="' + esc(h.img) + '" alt="" width="640" height="640" decoding="async" draggable="false"' + (h.imgStyle ? ' style="' + esc(h.imgStyle) + '"' : '') + '>';
    return '<div class="ffhc-scale"><div class="ffhc-card"><div class="ffhc-cin">' +
      '<div class="ffhc-cart">' + art + '</div>' +
      '<div class="ffhc-cband"><div class="ffhc-cid">' +
        '<div class="ffhc-cname">' + esc(h.name) + '</div>' +
        (h.type ? '<div class="ffhc-ctype">' + esc(h.type) + '</div>' : '') +
        (h.epithet ? '<div class="ffhc-cep">' + esc(h.epithet) + '</div>' : '') +
        (h.quote ? '<div class="ffhc-cq">“' + esc(h.quote) + '”</div>' : '') +
      '</div><span class="ffhc-cfoot"></span></div>' +
      '<span class="ffhc-csweep"></span></div></div></div>';
  }

  /* The collector's card's own fit (ff-binder.js feFit), so its words sit where the binder's card will put them: a
     long name shrinks to 72 %, then wraps to two lines; lines that still overflow the band step aside, the race and
     class first. Measured in the card's own 380 x 650 box, so the fan's scaling never changes the result. */
  function fitCard(root) {
    var nm = root.querySelector('.ffhc-cname'), band = root.querySelector('.ffhc-cband');
    if (nm) {
      nm.classList.remove('is-wrap');
      nm.style.fontSize = '';
      var cw = nm.clientWidth, sw = nm.scrollWidth;
      if (cw && sw > cw + 1) {
        var s = parseFloat(getComputedStyle(nm).fontSize) || 27;
        var est = Math.floor(s * cw / sw * 2) / 2;
        if (est >= s * 0.72) nm.style.fontSize = est + 'px';
        if (nm.scrollWidth > nm.clientWidth + 1) { nm.style.fontSize = ''; nm.classList.add('is-wrap'); }
      }
    }
    if (!band) return;
    ['.ffhc-ctype', '.ffhc-cep', '.ffhc-cq'].forEach(function (sel) {
      var x = band.querySelector(sel);
      if (x) x.style.display = '';
    });
    ['.ffhc-ctype', '.ffhc-cep', '.ffhc-cq'].forEach(function (sel) {
      if (band.scrollHeight <= band.clientHeight + 1) return;
      var x = band.querySelector(sel);
      if (x) x.style.display = 'none';
    });
  }

  /* Jan's signature writes itself in as a card lands in the middle, along the binder card's own pen strokes. A card away
     from the middle carries no signature yet (data-rv 0, the collector card's own unsigned state), so a card that lands is
     blank where the signature goes and only then signs, once (Jan, 2026-10-24: "make sure that the signature is not there
     at first, so that it doesn't show that the signature is there, it disappears, and then it redraws").
     Later the same day: "the signature drawn on each card is not smooth and its jagged and gltichy ... fix this on both
     mobile and desktop so it smoothly writes" and "the signature is signining too slowly, so make it faster and smoother".
     So the pen keeps her own handwriting rhythm (SIG_R and SIG_TT, copied from ff-collector.js, which rebuilds them from
     docs/prototypes/signed-and-numbered/signature/trace-timing.py; never by hand) but writes in PEN_MS instead of a second.
     When it lifts, the card simply shows the scan: the strokes uncover every bit of it, and the old second phase (the scan
     fading in over the strokes, data-rv 2) doubled the ink's soft edges, so the signature flashed bold and then thinned.
     The mask is a quarter-size copy of her scan (ff-signature-mask-sm.png, ff-collector.css), and the sharper picture
     waits until the pen has lifted (settle).
     Jan, 2026-10-28: "have the gleam play first, then the siganture smoothly after it and a tiny bit slower", then "the
     delay for the signature is too long and its still stuttering ... mainly near the beginning of the load it gets
     smoother later". The pen used to move the strokes from script, frame by frame, so anything else the page ran in a
     frame (Shopify's and the apps' scripts while the page loads, the binder drawing the cards behind) held it up and it
     jumped. Now every frame of the pen is drawn once, side by side on a sheet (PEN_F frames, PEN_COLS to a row, each one
     the card's own strokes, as <use> copies of ffhcSig0-4, over its own mask), and a small window over the signature shows
     them in turn by moving the sheet: a transform animation, which the browser runs by itself (the compositor; Core
     Animation on an iPhone) whatever the page's script is doing. Each frame holds until the next (two keyframes a hair
     apart: Safari runs steps() on the page's thread), and the cells are 50 by 75 card pixels, whole device pixels at every
     scale the deck uses. The gleam (.5 s, ffhcGlint in ff-hero-cards.css) and the pen are started from the same frame,
     the pen PEN_AT later, so however busy the page is the two never overlap. The last frame stays up until the card
     leaves the middle: the card's own signature underneath is drawn by the page and the frames by the compositor, which
     can land a hair lighter, so swapping one for the other as the pen lifts would show. */
  var SIG_R = [[0.0, 444.54], [444.54, 427.53], [872.07, 337.96], [1210.03, 331.86], [1541.89, 118.68]];
  var SIG_TT = [0.0, 8.1, 17.3, 28.6, 42.2, 56.6, 71.0, 85.5, 99.9, 114.3, 128.8, 143.2, 157.6, 172.1, 186.5, 201.0, 215.4, 229.8, 244.3, 258.7, 273.1, 287.6, 302.0, 316.5, 330.9, 345.3, 359.8, 374.2, 388.6, 402.9, 416.8, 430.0, 442.6, 455.1, 468.0, 481.7, 495.9, 510.3, 524.7, 539.2, 553.6, 568.0, 582.5, 596.9, 611.4, 625.8, 640.2, 654.7, 669.1, 683.5, 698.0, 712.4, 726.9, 741.3, 755.7, 770.2, 784.6, 799.0, 813.5, 827.8, 841.8, 855.1, 867.8, 880.2, 893.1, 906.7, 920.8, 935.2, 949.6, 964.0, 978.5, 992.9, 1007.3, 1021.8, 1036.2, 1050.6, 1065.1, 1079.5, 1093.9, 1108.4, 1122.8, 1137.3, 1151.7, 1166.0, 1180.0, 1193.3, 1206.0, 1218.4, 1231.3, 1244.9, 1259.0, 1273.4, 1287.8, 1302.2, 1316.7, 1331.1, 1345.5, 1360.0, 1374.4, 1388.9, 1403.3, 1417.7, 1432.2, 1446.6, 1461.0, 1475.5, 1489.9, 1504.1, 1517.8, 1530.8, 1543.3, 1555.9, 1569.0, 1582.9, 1596.9, 1610.1, 1622.2, 1632.9, 1642.7, 1651.8, 1660.6];
  var PEN_MS = 760, PEN_AT = 560, PEN_FADE = 340, PEN_F = 46, PEN_COLS = 8, PEN_W = 50, PEN_H = 75, penHtml = '', penKeys = null;
  function unsign(cc) {
    if (!cc || reduce) return;
    if (cc._ffhcInk) cc._ffhcInk();
    cc._ffhcSigned = false;
    cc.dataset.rv = '0';
  }
  /* the sheet (the same for every card: frame k is the pen at k / PEN_F of its run, in SIG_TT's rhythm) and the
     window's path across it; frame 0 is an empty cell past the last one */
  function penSheet() {
    if (penHtml) return penHtml;
    var N = SIG_TT.length - 1, k;
    for (k = 1; k <= PEN_F; k++) {
      var x = k / PEN_F * N, i = Math.min(N - 1, Math.floor(x)), at = SIG_TT[i] + (SIG_TT[i + 1] - SIG_TT[i]) * (x - i), u = '';
      for (var j = 0; j < SIG_R.length; j++) {
        var d = Math.max(0, Math.min(1, (at - SIG_R[j][0]) / SIG_R[j][1]));
        if (d > 0) u += '<use href="#ffhcSig' + j + '" stroke-dashoffset="' + (1 - d).toFixed(4) + '"/>';
      }
      penHtml += '<i class="cf-ink" style="left:' + ((k - 1) % PEN_COLS * PEN_W + 4) + 'px;top:' + (Math.floor((k - 1) / PEN_COLS) * PEN_H) + 'px"><svg class="ffc-sig" viewBox="0 0 474 640" focusable="false">' + u + '</svg></i>';
    }
    var cell = function (k) { var c = k ? k - 1 : PEN_F; return 'translate(' + (-(c % PEN_COLS) * PEN_W) + 'px,' + (-Math.floor(c / PEN_COLS) * PEN_H) + 'px)'; };
    penKeys = [{ offset: 0, transform: cell(0) }];
    for (k = 1; k <= PEN_F; k++) penKeys.push({ offset: k / PEN_F - 2e-6, transform: cell(k - 1) }, { offset: k / PEN_F, transform: cell(k) });
    return penHtml;
  }
  /* the card's own five strokes, once per page, for the sheet's <use> copies */
  function penPaths(paths) {
    if (document.getElementById('ffhcSig0')) return;
    var h = '<svg aria-hidden="true" focusable="false" width="0" height="0" style="position:absolute;width:0;height:0;overflow:hidden"><defs>';
    paths.forEach(function (p, j) { h += '<path id="ffhcSig' + j + '" d="' + esc(p.getAttribute('d')) + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="' + esc(p.getAttribute('stroke-width')) + '" stroke-linejoin="round" stroke-dasharray="1 1"/>'; });
    document.body.insertAdjacentHTML('beforeend', h + '</defs></svg>');
  }
  /* wait: how long the window shows the blank cell before the first stroke (the gleam's run and a beat, or the card's fade) */
  function ink(cc, wait, done) {
    if (!cc || !cc.isConnected) return;
    if (cc._ffhcInk) cc._ffhcInk();
    var paths = reduce ? [] : [].slice.call(cc.querySelectorAll('.cf-front .ffc-sig-rv')), sig = cc.querySelector('.cf-front .cf-sig');
    if (paths.length !== SIG_R.length || !sig || !sig.animate) { delete cc.dataset.rv; cc._ffhcSigned = true; if (done) done(); return; }
    penPaths(paths);
    var win = document.createElement('div');
    win.className = 'ffhc-pen';
    win.innerHTML = '<div class="ffhc-pen-s">' + penSheet() + '</div>';
    cc.dataset.rv = '0';
    cc.classList.add('ffhc-inked');
    sig.appendChild(win);
    var run = win.firstChild.animate(penKeys, { duration: PEN_MS, delay: Math.max(0, wait || 0), fill: 'both' });
    /* unsign (or a new pen) takes the window away and gives the card back its own signature */
    cc._ffhcInk = function () { run.onfinish = null; run.cancel(); win.remove(); cc.classList.remove('ffhc-inked'); cc._ffhcInk = null; };
    run.onfinish = function () {
      run.onfinish = null;
      if (!cc.isConnected) return;
      delete cc.dataset.rv;   /* the year fades in (ff-collector.css) */
      cc._ffhcSigned = true;
      if (done) done();
    };
  }

  /* the binder, once it can draw (ff-binder.js loads after this file) */
  function whenBinder(fn) {
    var done = false;
    function check() {
      var B = window.FFBinder;
      if (done || !B || typeof B.mountCollector !== 'function') return;
      done = true;
      fn(B);
    }
    check();
    if (done || document.readyState === 'complete') return;
    document.addEventListener('DOMContentLoaded', check, { once: true });
    window.addEventListener('load', check, { once: true });
  }

  /* pictures load and decode before they are needed; each url is fetched once */
  var pics = {};
  function loadPic(url) {
    if (!url) return Promise.resolve(false);
    if (pics[url]) return pics[url];
    pics[url] = new Promise(function (done) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { done(true); }, function () { done(true); }); };
      im.onerror = function () { done(false); };
      im.src = url;
    });
    return pics[url];
  }
  /* A sharper picture for the middle card on dense screens. The stored 400 px thumbnail is always what a card
     first shows (character-quest.js explains why the marquees never lean on Supabase's resize endpoint: a
     cold resize is slow). Here the resize only ever replaces a thumbnail that is already on screen, so a slow
     one costs nothing; a failed one keeps the thumbnail. */
  function sharpUrl(h, w) {
    w = w || 720;
    var m = /^(https:\/\/[^/]+\/storage\/v1\/)object(\/public\/[^?#]+)/.exec(h.full || '');
    return m ? m[1] + 'render/image' + m[2] + '?width=' + w + '&height=' + Math.round(w * 4 / 3) + '&resize=contain&quality=78' : '';
  }
  /* Nothing on a card here leads away (Jan, 2026-10-24: "dont make these clickalb eot open the hall"): the binder's
     card carries a link on its back ("Check this card", a new tab), which becomes plain words with the same look. */
  function unlink(root) {
    [].slice.call(root.querySelectorAll('a')).forEach(function (a) {
      var sp = document.createElement('span');
      sp.className = a.className;
      sp.innerHTML = a.innerHTML;
      a.parentNode.replaceChild(sp, a);
    });
  }

  function deck(root) {
    var wrap = root.querySelector('[data-ffhc-deck]');
    var stage = wrap && wrap.querySelector('.ffhc-stage');
    var printed = stage ? [].slice.call(stage.querySelectorAll('.ffhc-slot')) : [];
    if (!printed.length) return null;
    var open = stage.querySelector('[data-ffhc-open]');
    var live = wrap.querySelector('[data-ffhc-live]');
    var rotate = wrap.hasAttribute('data-ffhc-rotate');
    var interval = Math.max(3000, Math.min(12000, parseFloat(wrap.getAttribute('data-ffhc-interval')) || 5000));
    var editing = !!(window.Shopify && window.Shopify.designMode);

    var slots = [], heroes = [], offset = 0, first = 0, cur = 0, pos = 0;
    var timer = 0, tick = 0, holdUntil = 0, loading = null, dead = false, boxOpen = false;
    var userPaused = !rotate || reduce || editing, hover = false, focused = false, onscreen = true, dragging = false;

    function mod(a, n) { return ((a % n) + n) % n; }
    function heroAt(i) { return heroes.length ? heroes[mod(i - offset, heroes.length)] : null; }
    function slotAt(i) { for (var k = 0; k < slots.length; k++) if (slots[k].i === i) return slots[k]; return null; }

    /* the printed cards: the first sits in the middle, the second left, the third right */
    var seeds = { mid: null, left: null, right: null };
    printed.forEach(function (el) {
      var p = Math.round(parseFloat(el.style.getPropertyValue('--p')) || 0);
      var h = fromSlot(el);
      if (p === 0) seeds.mid = h; else if (p < 0) seeds.left = h; else seeds.right = h;
      slots.push({ el: el, i: p, hero: h, shown: h });
      el.addEventListener('animationend', function (e) { if (e.target === el) el.classList.remove('ffhc-deal'); });
    });
    function ringOf(rest) {
      return [seeds.mid, seeds.right].concat(rest || [], [seeds.left]).filter(Boolean);
    }
    heroes = ringOf();

    function makeSlot(i) {
      var el = document.createElement('div');
      el.className = 'ffhc-slot is-off is-empty';
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('--bob', (6 + mod(i * 3, 7) * 0.45).toFixed(2) + 's');
      el.innerHTML = '<div class="ffhc-tilt"></div>';
      stage.insertBefore(el, open || null);
      var s = { el: el, i: i, hero: null, shown: null };
      slots.push(s);
      return s;
    }
    for (var vi = -RADIUS; vi <= RADIUS; vi++) if (!slotAt(vi)) makeSlot(vi).hero = heroAt(vi);
    /* a short ring repeats heroes within the fan, so it shows only the middle three (see .ffhc-few), or with
       fewer than three heroes only the middle card (.ffhc-solo) */
    stage.classList.toggle('ffhc-few', heroes.length < 2 * SHOWN + 1);
    stage.classList.toggle('ffhc-solo', heroes.length < 3);

    /* ---------- painting ---------- */
    var fontsReady = !document.fonts || document.fonts.status === 'loaded';
    var binder = null, noBinder = false;
    function fill(s) {
      var h = s.hero;
      if (!h) return;
      if (s.shown === h) { dress(s); return; }
      s.el.firstElementChild.innerHTML = h.printed || cardHtml(h);
      s.shown = h;
      s.sharp = null;
      s.cc = null;
      s.dressing = null;
      s.el.classList.remove('is-empty');
      /* a card the binder is about to cover needs no fitting of its own */
      if (fontsReady && !(binder && !noBinder && h.row)) fitCard(s.el);
      dress(s);
    }
    /* The binder draws the hero's own collector's card over the slot's card: at once out of sight, with a short fade
       in sight. The card is a picture in the deck: it never turns over here (a tap opens the lightbox), takes no
       focus, stays flat (no 3D layers of its own, ff-collector.css .is-flat), and scales with the fan. */
    function dress(s) {
      var h = s.shown;
      if (!binder || noBinder || !h || !h.row || s.cc || s.dressing === h) return;
      if (!s.el.querySelector('.ffhc-scale')) return;
      s.dressing = h;
      /* its picture first, so the card never comes in with an empty frame (a tab that draws no frames never finishes
         decoding, so never more than a second and a half) */
      Promise.race([loadPic(h.row.image_url), new Promise(function (r) { setTimeout(r, 1500); })]).then(function () {
        if (s.shown === h && s.dressing === h && !dead) mount(s, h);
      });
    }
    function mount(s, h) {
      var box = s.el.querySelector('.ffhc-scale');
      if (!box) { s.dressing = null; return; }
      var host = document.createElement('div');
      host.className = 'ffhc-real';
      box.appendChild(host);
      binder.mountCollector(host, h.row, { s: 1, sign: false }).then(function (cc) {
        if (s.shown !== h || !host.isConnected) { host.remove(); return; }
        var fade = !reduce && !s.el.classList.contains('is-off') && !s.el.classList.contains('is-empty');
        if (!cc) { host.remove(); s.dressing = null; noBinder = true; return; }   /* its stylesheet can't load: keep these cards */
        cc.style.setProperty('--s', 'inherit');
        cc.classList.add('is-flat');
        cc.classList.remove('is-tap');
        ['tabindex', 'role', 'aria-roledescription', 'aria-label'].forEach(function (a) { cc.removeAttribute(a); });
        unlink(cc);
        if (h.video) {
          var art = cc.querySelector('.cf-art');
          if (art) art.insertAdjacentHTML('beforeend', '<video src="' + esc(h.video) + '" poster="' + esc(h.img) + '" muted playsinline loop preload="none" data-ffhc-autoplay></video>');
        }
        s.cc = cc;
        /* a card dressed away from the middle waits unsigned */
        if (s.i !== cur) unsign(cc);
        var old = box.querySelector('.ffhc-card'), mid = s.i === cur, again = mid && s.sharp === h;
        if (again) s.sharp = null;
        if (mid && fade) cc.dataset.rv = '0';
        if (fade) {
          nextFrame(function () {
            host.classList.add('is-in');
            /* the card that comes in in the middle signs as soon as it has faded in, or, when it brings its own gleam (it
               lands just now), once that has passed; a sharper picture waits until the pen lifts */
            if (mid && s.cc === cc && slotAt(cur) === s) ink(cc, s.el.classList.contains('is-arrived') ? PEN_AT : PEN_FADE, function () { if (again && s.cc === cc) sharpen(s); });
            setTimeout(function () { if (old && s.cc === cc) old.remove(); }, 380);
          });
        } else {
          host.classList.add('is-in', 'is-now');
          if (old) old.remove();
        }
        if (mid) {
          if (!fade && again) sharpen(s);
          videos();
        }
      }, function () { if (s.shown === h) { host.remove(); s.dressing = null; } });
    }
    /* the middle card and its neighbours now, the rest a card at a time when the page is idle */
    function dressAll() {
      var mid = slotAt(cur);
      if (mid) dress(mid);
      slots.forEach(function (s) { if (Math.abs(s.i - cur) <= 1) dress(s); else fillLater(s); });
    }
    var idleQ = [];
    function fillLater(s) {
      if (idleQ.indexOf(s) === -1) idleQ.push(s);
      if (idleQ.length > 1) return;
      var run = function () {
        if (dead) return;
        /* never mid-swipe or mid-glide: a card out of sight is drawn once the deck has come to rest */
        var rest = dragging ? 300 : lastMove + 1000 - Date.now();
        if (rest > 0) { setTimeout(function () { later(run); }, rest); return; }
        var s2 = idleQ.shift();
        if (s2) fill(s2);
        if (idleQ.length) later(run);
      };
      later(run);
    }
    function nextFrame(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }
    function later(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 700 }); else setTimeout(fn, 120); }
    /* every slot that is, or is about to be, in sight gets its hero now */
    function fillNear(reach) {
      var mid = Math.round(pos);
      slots.forEach(function (s) { if (Math.abs(s.i - mid) <= reach) fill(s); });
    }

    function setP(s, p) {
      p = Math.max(-RADIUS, Math.min(RADIUS, p));
      var a = Math.abs(p), mid = a < 0.5;
      s.el.style.setProperty('--p', String(Math.round(p * 1e4) / 1e4));
      s.el.style.zIndex = String(10 - Math.round(Math.min(a, SHOWN)) * 2);
      s.el.classList.toggle('is-off', a > SHOWN - 0.02);
      /* only the middle card and its two neighbours take taps; the faint (or, on some widths, invisible) cards
         behind them never do */
      s.el.classList.toggle('is-far', a > 1.5);
      if (mid !== s.el.classList.contains('is-center')) {
        s.el.classList.toggle('is-center', mid);
        if (!mid) s.el.classList.remove('is-arrived');
      }
    }
    /* Put every slot where pos says. Slots that fell out of the window jump, unseen, to the open end, and when the
       deck glides they enter from out of sight on that side. */
    function restore(el) { return function () { el.style.transition = ''; }; }
    function layout(glide) {
      var mid = Math.round(pos), lo = mid - RADIUS, hi = mid + RADIUS, have = {}, spare = [];
      slots.forEach(function (s) { if (s.i >= lo && s.i <= hi && !have[s.i]) have[s.i] = s; else spare.push(s); });
      for (var i = lo; i <= hi; i++) {
        if (have[i] || !spare.length) continue;
        var s = spare.shift();
        s.i = i;
        s.hero = heroAt(i);
        /* it jumps, unseen, without a forced style pass: its glide comes back two frames on */
        s.el.style.transition = 'none';
        setP(s, glide ? (i > pos ? RADIUS : -RADIUS) : i - pos);
        if (glide) nextFrame(restore(s.el)); else s.el.style.transition = '';
        fillLater(s);
      }
      slots.forEach(function (s) { setP(s, s.i - pos); });
    }

    /* ---------- moving ---------- */
    function undeal() { printed.forEach(function (el) { el.classList.remove('ffhc-deal'); }); }
    var lastMove = 0;
    function go(target, how) {
      target = Math.round(target);
      if (target === cur && pos === target) { schedule(); return; }
      tick++;
      clearTimeout(timer);
      undeal();
      lastMove = Date.now();
      stage.style.setProperty('--ffhc-glide', how === 'auto' ? '.95s' : how === 'drag' ? '.5s' : '.62s');
      cur = pos = target;
      layout(true);
      fillNear(2);
      settle(how);
    }
    function step(d) { hold(); go(cur + d, 'tap'); }
    /* the middle slot speaks for the deck: its label, and the button that shows its card big */
    function label(how) {
      var s = slotAt(cur), h = s && s.hero;
      slots.forEach(function (x) {
        if (x === s) { x.el.removeAttribute('aria-hidden'); x.el.setAttribute('role', 'group'); x.el.setAttribute('aria-roledescription', 'slide'); }
        else { x.el.setAttribute('aria-hidden', 'true'); x.el.removeAttribute('role'); x.el.removeAttribute('aria-roledescription'); x.el.removeAttribute('aria-label'); }
      });
      if (!s || !h) return s;
      var n = heroes.length, k = mod(cur - offset - first, n) + 1;   /* the first card counts as 1 */
      s.el.setAttribute('aria-label', h.name + ', ' + k + ' of ' + n);
      if (open) open.setAttribute('aria-label', 'Show ' + h.name + "'s card");
      if (how && how !== 'auto' && live) live.textContent = h.name + (h.type ? ', ' + h.type.replace(' · ', ' ') : '') + '. ' + k + ' of ' + n + '.';
      return s;
    }
    var settleT = 0;
    function settle(how) {
      var s = label(how), sign = !!(how && s && s.cc && !s.cc._ffhcSigned && !reduce);
      /* the signature once the card has come to rest and its gleam has passed (cards that left the middle are unsigned
         again), the sharper picture once it has. The gleam and the pen start from the same frame. */
      var later = function () { if (s && slotAt(cur) === s) sharpen(s); };
      if (s && s.hero && !reduce) {
        s.el.classList.remove('is-arrived');
        nextFrame(function () {
          if (dead || slotAt(cur) !== s) return;
          s.el.classList.add('is-arrived');
          if (sign && s.cc && !s.cc._ffhcSigned) ink(s.cc, PEN_AT, function () { if (slotAt(cur) === s) settleT = setTimeout(later, 120); });
        });
      }
      videos();
      warm();
      clearTimeout(settleT);
      slots.forEach(function (o) { if (o !== s && o.cc && (o.cc._ffhcSigned || o.cc._ffhcInk || o.cc.dataset.rv !== '0')) unsign(o.cc); });
      if (sign) { if (!s.cc._ffhcInk) s.cc.dataset.rv = '0'; }
      else settleT = setTimeout(later, how === 'auto' ? 1000 : 700);
      schedule();
    }
    function warm() {
      for (var i = cur - 2; i <= cur + 4; i++) { var h = heroAt(i); if (h) loadPic(h.img); }
    }
    function sharpen(s) {
      var h = s.hero, img = s.el.querySelector(s.cc ? '.ffhc-real .cf-art img' : '.ffhc-cart img');
      if (!h || !img || s.sharp === h || saveData || (h.printed && !s.cc)) return;
      s.sharp = h;
      var url = sharpUrl(h);
      if (!url || img.naturalWidth >= 700) return;
      if (img.getBoundingClientRect().width * (window.devicePixelRatio || 1) <= 440) return;
      loadPic(url).then(function (ok) { if (ok && s.shown === h && img.isConnected) img.src = url; });
    }
    function videos() {
      slots.forEach(function (s) {
        var v = s.el.querySelector('video[data-ffhc-autoplay]');
        if (!v) return;
        v.muted = true;
        if (s.i === cur && onscreen && !reduce && !saveData && !document.hidden) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else v.pause();
      });
    }

    /* ---------- the timer ---------- */
    function hold() { holdUntil = Date.now() + Math.round(interval * 1.6); }
    function running() { return !userPaused && !hover && !focused && onscreen && !dragging && !boxOpen && !document.hidden && !dead; }
    function schedule() {
      clearTimeout(timer);
      timer = 0;
      if (!running()) return;
      var wait = Math.max(interval, holdUntil - Date.now());
      var mine = ++tick;
      timer = setTimeout(function () {
        timer = 0;
        /* the next hero waits for its picture (and the first one for the list), never for more than 4 seconds */
        var need = [loading || true];
        for (var i = cur + 1; i <= cur + 3; i++) { var h = heroAt(i); if (h) need.push(loadPic(h.img)); }
        Promise.race([Promise.all(need), new Promise(function (r) { setTimeout(r, 4000); })]).then(function () {
          if (mine === tick && running()) go(cur + 1, 'auto');
        });
      }, wait);
    }
    function setPaused(p) {
      userPaused = p;
      schedule();
    }

    /* ---------- the list ---------- */
    function adopt(list) {
      var named = [seeds.mid, seeds.left, seeds.right];
      var mine = named.map(function (sd) {
        if (!sd) return sd;
        var m = list.filter(function (h) { return sameHero(sd, h); })[0];
        if (!m) return sd;
        /* the printed card stays until the binder's card covers it; that one shows the Hall's own picture, framed as
           in the Hall */
        m.printed = sd.printed;
        return m;
      });
      seeds = { mid: mine[0], left: mine[1], right: mine[2] };
      var rest = list.filter(function (h) { return !named.some(function (sd) { return sameHero(sd, h); }); });
      var planned = ringOf(rest), n = planned.length;
      function at(arr, h) { for (var k = 0; k < arr.length; k++) if (sameHero(arr[k], h)) return k; return -1; }
      /* Whatever is on screen stays put: the middle hero and its two neighbours keep their places, in order, and
         everyone else follows them round the ring in the planned order. Untouched, that is exactly the planned
         ring (left, middle, right, then the rest); after early taps it never puts a hero on screen twice. */
      var run = [], start = cur;
      [cur, cur - 1, cur + 1].forEach(function (i) {
        var s = slotAt(i), k = s && s.hero ? at(planned, s.hero) : -1;
        if (k < 0 || at(run, planned[k]) >= 0 || (i !== cur && !run.length)) return;
        if (i < cur) { run.unshift(planned[k]); start = i; } else run.push(planned[k]);
      });
      if (run.length) {
        var last = at(planned, run[run.length - 1]), after = [];
        for (var k = 1; k <= n; k++) { var p = planned[mod(last + k, n)]; if (at(run, p) < 0) after.push(p); }
        heroes = run.concat(after);
        offset = start;
      } else {
        heroes = planned;
        offset = cur;
      }
      first = Math.max(0, at(heroes, seeds.mid));
      slots.forEach(function (s) {
        var want = heroAt(s.i), far = Math.abs(s.i - cur);
        if (far <= 1 && sameHero(s.hero, want)) { if (s.shown === s.hero) s.shown = want; s.hero = want; }
        else if (far <= 2) { s.hero = want; fill(s); }
        else { s.hero = want; fillLater(s); }
      });
      stage.classList.toggle('ffhc-few', heroes.length < 2 * SHOWN + 1);
      stage.classList.toggle('ffhc-solo', heroes.length < 3);
      label(null);
      warm();
      dressAll();
    }
    /* the list joins the deck only while it is still, so no card on screen changes picture mid-swipe or mid-glide */
    var pendingList = null;
    function adoptWhenStill() {
      if (!pendingList || dead) return;
      var wait = dragging ? 400 : lastMove + 1000 - Date.now();
      if (wait > 0) { setTimeout(adoptWhenStill, wait); return; }
      var list = pendingList;
      pendingList = null;
      adopt(list);
    }
    function loadList() {
      if (!window.ffShowcase || dead) return;
      loading = window.ffShowcase.get({ count: 200, fill: false, stories: false, cards: true })
        .then(function (rows) {
          /* Jan's featured FramedFantasy portraits: the heroes with a collector's card */
          var list = (rows || []).filter(function (h) { return h && h.isFF && (h.thumb || h.image); }).map(fromShowcase);
          /* a deck that doesn't deal still dresses its own cards */
          if (!rotate) list = list.filter(function (h) { return [seeds.mid, seeds.left, seeds.right].some(function (sd) { return sameHero(sd, h); }); });
          if (list.length && !dead) { pendingList = list; adoptWhenStill(); }
        })
        .catch(function () {})
        .then(function () { loading = null; });
    }

    /* ---------- hands ---------- */
    var drag = null, swallowUntil = 0;
    function stepPx() {
      var w = slots[0].el.offsetWidth || 200;
      var x1 = parseFloat(getComputedStyle(stage).getPropertyValue('--x1')) || 55;
      return Math.max(60, w * x1 / 100);
    }
    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (drag && drag.live) return;   /* a second finger never takes over a swipe */
      /* a finger on the deck holds the timer, so a tap on the middle card always shows the hero it was on */
      tick++;
      clearTimeout(timer);
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, from: pos, live: false, step: stepPx(), hist: [[e.timeStamp, e.clientX]] };
    }
    function onMove(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.live) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) >= Math.abs(dx)) { drag = null; schedule(); return; }   /* a scroll, not a swipe */
        drag.live = true;
        dragging = true;
        tick++;
        undeal();
        try { stage.setPointerCapture(e.pointerId); } catch (_) {}
        wrap.classList.add('is-dragging');
        schedule();
      }
      drag.hist.push([e.timeStamp, e.clientX]);
      if (drag.hist.length > 6) drag.hist.shift();
      pos = drag.from - dx / drag.step;
      layout(false);
      fillNear(2);
      if (e.cancelable) e.preventDefault();
    }
    function onUp(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.live) { schedule(); return; }
      dragging = false;
      swallowUntil = Date.now() + 400;
      wrap.classList.remove('is-dragging');
      /* A swipe deals one hero, a hard flick one more; a slow drag lands on the card nearest the middle. */
      var v = 0, a = d.hist[0], b = d.hist[d.hist.length - 1];
      if (b[0] > a[0] && e.timeStamp - b[0] < 120) v = (b[1] - a[1]) / (b[0] - a[0]);
      var start = Math.round(d.from), moved = pos - d.from, flick = v > 0 ? -1 : v < 0 ? 1 : 0;
      var target = Math.round(pos);
      if (target === start) {
        if (Math.abs(moved) > 0.15) target = start + (moved > 0 ? 1 : -1);
        else if (Math.abs(v) > 0.35) target = start + flick;
      }
      if (Math.abs(v) > 1.4 && flick && flick === Math.sign(target - start)) target += flick;
      target = Math.max(Math.round(pos) - 2, Math.min(Math.round(pos) + 2, target));
      hold();
      go(target, 'drag');
    }
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove, { passive: false });
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    /* the deck itself losing the finger ends the swipe; a card's own implicit touch capture, handed to the deck as a
       swipe starts, bubbles up here too and must not */
    stage.addEventListener('lostpointercapture', function (e) { if (e.target === stage) onUp(e); });
    /* a swipe never also opens the middle hero; a tap on a side card brings that hero to the middle */
    stage.addEventListener('click', function (e) {
      if (Date.now() < swallowUntil) { e.preventDefault(); e.stopPropagation(); return; }
      var el = e.target.closest && e.target.closest('.ffhc-slot');
      if (!el || el.classList.contains('is-center')) return;
      for (var k = 0; k < slots.length; k++) if (slots[k].el === el) { e.preventDefault(); hold(); go(slots[k].i, 'tap'); return; }
    }, true);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* a sideways trackpad swipe deals one hero per gesture */
    var wAcc = 0, wLast = 0, wDone = false;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) * 1.2) return;
      e.preventDefault();
      if (e.timeStamp - wLast > 220) { wDone = false; wAcc = 0; }
      wLast = e.timeStamp;
      if (wDone) return;
      wAcc += e.deltaX;
      if (Math.abs(wAcc) >= 40) { wDone = true; step(wAcc > 0 ? 1 : -1); }
    }, { passive: false });
    /* ---------- the lightbox ----------
       Jan, 2026-10-24: "dont make these clickalb eot open the hall, the most it, is that it should open the lightbox to
       showoff the card without opening a new tab on the main hero of the webiste". A tap on the middle card shows that
       card big over the dimmed page, Jan's signature writing itself in; a tap on the card turns it over (the binder's
       own turn) and back; X, Escape or a tap beside it closes it. The deck holds still while it is open. */
    var box = root.querySelector('[data-ffhc-box]'), boxStage = box && box.querySelector('[data-ffhc-box-stage]');
    var boxTip = box && box.querySelector('[data-ffhc-box-tip]'), boxClose = box && box.querySelector('[data-ffhc-box-close]');
    var boxSeq = 0, boxT = 0, boxDone = null, boxLock = null;
    function boxScale() {
      var phone = innerWidth < 600;
      /* the card sits well inside the screen with room around it (Jan, 2026-10-24: "same with on the home page, when you
         click the hero banner cards, make these cards a bit smaller when enlarged"), the binder's card view's size */
      return Math.max(0.45, Math.min((innerHeight - (phone ? 150 : 140)) * 0.84 / 650, innerHeight * 0.66 / 650, (innerWidth - (phone ? 72 : 190)) / 380, 0.94));
    }
    function boxSize() {
      var k = boxScale().toFixed(4), cc = boxStage.querySelector('.ffc-cc');
      boxStage.style.setProperty('--k', k);
      if (cc) cc.style.setProperty('--s', k);
    }
    /* the page stays where it was under the lightbox (the reviews dialog's way) */
    function lockScroll() {
      var b = document.body, y = window.scrollY, bar = Math.max(0, innerWidth - document.documentElement.clientWidth);
      boxLock = { y: y, css: b.style.cssText };
      b.style.position = 'fixed'; b.style.top = -y + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; b.style.overflow = 'hidden';
      if (bar) b.style.paddingRight = bar + 'px';
    }
    function unlockScroll() {
      if (!boxLock) return;
      var L = boxLock, html = document.documentElement, was = html.style.scrollBehavior;
      boxLock = null;
      document.body.style.cssText = L.css;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, L.y);
      html.style.scrollBehavior = was;
    }
    function showCard() {
      var s = slotAt(cur), h = s && s.shown;
      if (!box || !boxStage || !h || boxOpen || typeof box.showModal !== 'function') return;
      if (boxDone) boxDone();
      var seq = ++boxSeq, real = !!(binder && !noBinder && h.row);
      boxOpen = true;
      schedule();
      box.setAttribute('aria-label', h.name + ', collector\u2019s card');
      boxStage.innerHTML = '';
      boxSize();
      /* until the binder can draw it, the card as the deck shows it */
      function asShown() {
        var ph = s.el.querySelector('.ffhc-card');
        if (!ph) return;
        boxStage.innerHTML = '<div class="ffhc-box-ph"></div>';
        boxStage.firstChild.appendChild(ph.cloneNode(true));
        if (boxTip) boxTip.hidden = true;
      }
      if (boxTip) {
        boxTip.hidden = !real;
        boxTip.textContent = (window.matchMedia && matchMedia('(pointer: fine)').matches ? 'Click' : 'Tap') + ' the card to turn it over';
      }
      if (real) {
        var host = document.createElement('div');
        host.className = 'ffhc-box-card';
        boxStage.appendChild(host);
        binder.mountCollector(host, h.row, { s: boxScale(), sign: false }).then(function (cc) {
          if (seq !== boxSeq) return;
          if (!cc) { asShown(); return; }
          cc.classList.add('is-flat');
          unlink(cc);
          /* it signs the deck's way, once the card has grown in (still unsigned on its first frame: this runs before the
             browser draws the card); turning it over mid-pen just finishes the signature */
          if (!reduce) {
            ink(cc, 300);
            var penOff = function (e) {
              if (cc._ffhcInk && (e.type === 'click' || e.key === 'Enter' || e.key === ' ')) { cc._ffhcInk(); delete cc.dataset.rv; cc._ffhcSigned = true; }
            };
            cc.addEventListener('click', penOff, true);
            cc.addEventListener('keydown', penOff, true);
          }
          /* the card big wants a bigger picture than the deck's: it comes in once it has loaded */
          var img = cc.querySelector('.cf-art img'), big = sharpUrl(h, 1000) || h.full;
          if (img && big && big !== img.getAttribute('src') && !saveData) loadPic(big).then(function (ok) { if (ok && seq === boxSeq && img.isConnected) img.src = big; });
        }, function () { if (seq === boxSeq) asShown(); });
      } else asShown();
      lockScroll();
      try { box.showModal(); } catch (e) { boxOpen = false; unlockScroll(); schedule(); return; }
      if (boxClose) boxClose.focus({ preventScroll: true });
      requestAnimationFrame(function () { if (seq === boxSeq && boxOpen) box.classList.add('is-on'); });
    }
    function hideCard(now) {
      if (!boxOpen) return;
      boxOpen = false;
      var seq = ++boxSeq;
      box.classList.remove('is-on');
      clearTimeout(boxT);
      boxDone = function () {
        clearTimeout(boxT);
        boxDone = null;
        if (box.open) box.close();
        if (seq === boxSeq) boxStage.innerHTML = '';
        unlockScroll();
        if (open && open.isConnected && !dead) open.focus({ preventScroll: true });
        schedule();
      };
      if (now || reduce) boxDone(); else boxT = setTimeout(boxDone, 220);
    }
    if (open) open.addEventListener('click', function () { showCard(); });
    if (box) {
      box.addEventListener('cancel', function (e) { e.preventDefault(); hideCard(); });
      box.addEventListener('close', function () { if (boxOpen) hideCard(true); });
      /* a tap anywhere but the card (or a turn of it) closes */
      box.addEventListener('click', function (e) { if (!e.target.closest('.ffc-cc, .ffhc-card')) hideCard(); });
    }
    function onBoxResize() { if (boxOpen) boxSize(); }
    window.addEventListener('resize', onBoxResize);

    wrap.addEventListener('keydown', function (e) {
      /* a keyboard in the deck holds it, like a resting mouse; Tab away and it carries on */
      if (!focused) { focused = true; schedule(); }
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;   /* Alt+arrows stay the browser's Back/Forward */
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      step(e.key === 'ArrowRight' ? 1 : -1);
    });
    /* resting a mouse on the deck, or a keyboard inside it, holds the current hero */
    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; schedule(); } });
    wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; schedule(); } });
    wrap.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (_) {}
      if (kb) { focused = true; schedule(); }
    });
    wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) { focused = false; schedule(); } });
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { onscreen = en[en.length - 1].isIntersecting; videos(); schedule(); }, { threshold: 0.2 });
      io.observe(stage);
    }
    function onVis() { videos(); schedule(); }
    document.addEventListener('visibilitychange', onVis);
    if (!fontsReady) document.fonts.ready.then(function () {
      fontsReady = true;
      if (!dead) slots.forEach(function (s) { if (s.shown) fitCard(s.el); });
    });

    if (fontsReady) printed.forEach(fitCard);
    layout(false);
    fillNear(heroes.length < 2 * SHOWN + 1 ? 1 : 2);
    label(null);
    wrap.classList.add('is-live');
    /* the first hero also gets the deal-in time, so Ember holds the middle as long as everyone after her */
    holdUntil = Date.now() + interval + 2000;
    setPaused(userPaused);
    /* the list (and with it the binder's cards and the first signature) is asked for at once: it is a network wait */
    setTimeout(loadList, 0);
    whenBinder(function (B) { if (dead) return; binder = B; dressAll(); });
    return {
      destroy: function () {
        dead = true;
        clearTimeout(timer);
        clearTimeout(settleT);
        if (io) io.disconnect();
        document.removeEventListener('visibilitychange', onVis);
        window.removeEventListener('resize', onBoxResize);
        hideCard(true);
      }
    };
  }

  function tilt(root) {
    if (reduce || !window.matchMedia || !matchMedia('(pointer: fine)').matches) return;
    root.querySelectorAll('[data-ffhc-tilt]').forEach(function (el) {
      var raf = 0, mx = 0, my = 0, lit = null;
      /* the middle collector's card catches the light: its foil and glare follow the pointer (ff-collector.css --mx,
         --gx, --gy and .is-hover, as on the collector page) */
      function unlight() { if (lit) { lit.classList.remove('is-hover'); lit.style.removeProperty('--mx'); lit = null; } }
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        mx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
        my = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          el.style.setProperty('--mx', mx.toFixed(3));
          el.style.setProperty('--my', my.toFixed(3));
          var cc = el.querySelector('.ffhc-slot.is-center .ffhc-real .ffc-cc');
          if (cc !== lit) unlight();
          if (!cc) return;
          lit = cc;
          cc.classList.add('is-hover');
          cc.style.setProperty('--mx', ((mx + 1) * 50).toFixed(1));
          cc.style.setProperty('--gx', ((mx + 1) * 50).toFixed(1) + '%');
          cc.style.setProperty('--gy', ((my + 1) * 50).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--mx', '0');
        el.style.setProperty('--my', '0');
        unlight();
      });
    });
  }

  function countUp(root) {
    var els = root.querySelectorAll('[data-ffhc-count]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var to = parseInt(el.getAttribute('data-ffhc-count'), 10);
        if (!to) return;
        var suffix = el.getAttribute('data-ffhc-suffix') || '';
        var t0 = 0;
        el.style.minWidth = el.getBoundingClientRect().width + 'px';
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1500);
          var e = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(to * e).toLocaleString('en-US') + suffix;
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  // The rating is worked out from the product's own star counts and rounded down to one decimal, so it never
  // overstates (635 reviews averaging 4.97 read 4.9). The count is the product's live review total.
  function looxRating(root) {
    var el = root.querySelector('[data-ffhc-loox-store]');
    if (!el || !window.fetch) return;
    var store = el.getAttribute('data-ffhc-loox-store');
    var product = el.getAttribute('data-ffhc-loox-product');
    if (!store || !product) return;
    fetch('https://storefront-api.loox.io/storefront/v1/store/' + encodeURIComponent(store) + '/product-reviews/bottomline/' + encodeURIComponent(product))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        var dist = d.ratingDistribution || {}, total = 0, sum = 0;
        Object.keys(dist).forEach(function (k) { var n = Number(dist[k]) || 0; total += n; sum += n * Number(k); });
        var avg = total ? sum / total : Number(d.averageRating);
        var count = Number(d.totalReviews) || total;
        if (!avg || !count) return;
        var rating = el.querySelector('[data-ffhc-rating]');
        var reviews = el.querySelector('[data-ffhc-reviews]');
        if (rating) rating.textContent = (Math.floor(avg * 10 + 1e-9) / 10).toFixed(1);
        if (reviews) reviews.textContent = count.toLocaleString('en-US');
      })
      .catch(function () {});
  }

  var decks = [];
  function init(root) {
    if (!root || root.hasAttribute('data-ffhc-ready')) return;
    root.setAttribute('data-ffhc-ready', '');
    var d = null;
    try { d = deck(root); } catch (err) { if (window.console) console.warn('ff-hero-cards deck', err); }
    if (d) decks.push({ root: root, deck: d });
    tilt(root);
    countUp(root);
    looxRating(root);
  }

  function initAll() { document.querySelectorAll('.ffhc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // the theme editor re-renders a section in place
  document.addEventListener('shopify:section:unload', function (e) {
    decks = decks.filter(function (x) {
      if (e.target && e.target.contains(x.root)) { x.deck.destroy(); return false; }
      return true;
    });
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.ffhc') : null;
    init(root);
  });
})();
